import ShareableLinkNdaConnecting from './ShareableLinkNdaConnecting.component';

export default ShareableLinkNdaConnecting;